import { Box, Icon, Text } from '@factorialco/deprecated-design-system'

import { EmployeeAvatar } from 'modules/employees/components/EmployeeAvatar'

interface Props {
  employee: EmployeeCellContentType
  open: boolean
  isChevronHidden: boolean
}

export type EmployeeCellContentType = {
  id: number
  fullName: string
  avatar: string
  jobTitle: string
}

const EmployeeCellContent = ({ employee, open, isChevronHidden = false }: Props) => {
  return (
    <Box
      flexDirection="row"
      gap="s8"
      minWidth="none"
      padding="s8"
      height="s80"
      justifyContent="spaceBetween"
    >
      <Box flexDirection="row" gap="s8">
        <EmployeeAvatar
          variant="medium"
          employee={{
            id: employee.id,
            access: {
              id: employee.id,
              fullName: employee.fullName,
              avatar: employee.avatar,
            },
          }}
        />
        <Box overflowX="hidden" gap="s4" width="s140">
          <Text size="200" weight="medium" color="grey1000" ellipsis>
            {employee.fullName}
          </Text>
          <Text size="100" color="grey800" ellipsis>
            {employee.jobTitle}
          </Text>
        </Box>
      </Box>
      <Box width="fit-content">
        {!isChevronHidden && (
          <Icon.Small icon={open ? 'chevron-up' : 'chevron-down'} color="grey800" />
        )}
      </Box>
    </Box>
  )
}

export default EmployeeCellContent
